import { RawEntityDisplayConfigField } from '../interfaces/entity-display-config';

export const CREATE_OBJECTS_DISPLAY_CONFIG_TEMPLATE_FIELDS: Array<RawEntityDisplayConfigField> = [
  {
    name: 'inserted',
    type: 'LONG',
    display_name: 'Inserted'
  }
];

export const EDIT_OBJECTS_DISPLAY_CONFIG_TEMPLATE_FIELDS: Array<RawEntityDisplayConfigField> = [
  ...CREATE_OBJECTS_DISPLAY_CONFIG_TEMPLATE_FIELDS,
  {
    name: 'updated',
    type: 'LONG',
    display_name: 'Updated'
  },
  {
    name: 'deleted',
    type: 'LONG',
    display_name: 'Deleted'
  }
];
